module.exports = __webpack_public_path__ + "static/media/map.71c80642.png";